<template>
  <component :is="icon" class="gs-transaction-status-icon" :class="['gs-transaction-status-icon--' + tone, { 'is-checking': icon === 'LoaderIcon' }]"
    size="16" stroke-width="1.75" aria-hidden="true" focusable="false" />
</template>
<script>
import { RepeatIcon, SlashIcon, MinusCircleIcon, CornerUpLeftIcon, PieChartIcon, RotateCcwIcon,
  XCircleIcon, XIcon, ClockIcon, CalendarIcon, AlertTriangleIcon, InfoIcon, LoaderIcon } from 'vue-feather-icons';
export default {
  components: { RepeatIcon, SlashIcon, MinusCircleIcon, CornerUpLeftIcon, PieChartIcon, RotateCcwIcon,
    XCircleIcon, XIcon, ClockIcon, CalendarIcon, AlertTriangleIcon, InfoIcon, LoaderIcon },
  props: { icon: { type: String, required: true }, tone: { type: String, default: 'muted' } },
};
</script>
